import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import { v4 as uuid } from 'uuid';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';

export class CheckboxEditCell extends Component {
  constructor(props) {
    super(props);
    this.id = `i${uuid()}`;
  }

  render() {
    const { name, errors } = this.props;
    return (
      <Field name={name}>
        {({ field, form }) => {
          const error = getIn(errors.toJS(), name);

          return (
            <div className="haz-bulk-edit-field custom-control custom-checkbox">
              <input
                id={this.id}
                type="checkbox"
                className={classnames({ 'custom-control-input': true, 'is-invalid': Boolean(error) })}
                checked={field.value}
                onChange={() => {
                  form.setFieldValue(name, !field.value);
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="custom-control-label" htmlFor={this.id} />
              {error && <UncontrolledTooltip className="haz-bulk-edit-field-error" target={this.id}>{error}</UncontrolledTooltip>}
            </div>
          );
        }}
      </Field>
    );
  }
}

CheckboxEditCell.propTypes = {
  name: PropTypes.string.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
};

CheckboxEditCell.defaultProps = {
};
